import React from 'react'
import Pagination from 'components/Pagination'

import { TAB_TYPES } from '../../utils/constants'
import ProjectBlock from '../ProjectBlock/ProjectBlock'
import EmptyProjectList from './EmptyProjectList'
import StubProjectList from './StubProjectList'

export const ProjectList = ({
    isLoading,
    tab,
    projects,
    actionLoading,
    onOpenModal,
    onEditProject,
    onOpenShareModal,
    onDuplicateProject,
    onChangeProjectVisibility,
    onCopyToOrganization,
    onPaginationClick,
    onRenameProject,
    onCreateProject,
}) => {
    const projectsInfo = projects[tab]
    const isPublishedTab = tab === TAB_TYPES.published

    if (isLoading) return <StubProjectList tab={tab} />

    if (!projectsInfo.content.length)
        return <EmptyProjectList isPublishedTab={isPublishedTab} onCreateProject={onCreateProject} />

    return (
        <>
            <ul className="project-list">
                {projectsInfo.content.map(item => {
                    return (
                        <ProjectBlock
                            key={item.id}
                            project={item}
                            actionLoading={actionLoading}
                            onEditProject={onEditProject}
                            onDuplicateProject={onDuplicateProject}
                            onChangeProjectVisibility={onChangeProjectVisibility}
                            onCopyToOrganization={onCopyToOrganization}
                            onOpenModal={onOpenModal}
                            onOpenShareModal={onOpenShareModal}
                            onRenameProject={onRenameProject}
                        />
                    )
                })}
            </ul>

            <div className={`pagination-wrapper${projectsInfo.pagination.totalPages > 1 ? ' is-visible' : ''}`}>
                <Pagination
                    settings={{ disableInitCallback: true, marginPages: 1, pageRange: 4 }}
                    data={{
                        currentPage: projectsInfo.pagination.offsetPages,
                        totalPages: projectsInfo.pagination.totalPages,
                    }}
                    events={{ handleClick: onPaginationClick(tab) }}
                />
            </div>
        </>
    )
}
